<template>
  <v-dialog @update:returnValue="setEditItemIdZero" v-model="dialogResult" max-width="500px" persistent>
    <v-card>
      <v-card-text class="text-md-center">
        <v-flex xs12 sm6 md12>
          <v-select
            :items="formsList"
            label="Form ID"
            v-model="itemData.forms_id"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-text-field
            label="Body"
            v-model="itemData.body"
            textarea
          ></v-text-field>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click.stop="editItemData">Save</v-btn>
        <v-btn color="primary" flat @click.stop="dialogClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import dialogMixins from '@/mixins/EditResourceDialog'
  import formsAPI from '@/api/resources/forms'

  export default {
    data () {
      return {
        resource: 'templates',
        formsList: []
      }
    },
    mixins: [ dialogMixins ],
    created () {
      formsAPI.loadForms().then(result => {
        this.formsList = result
      })
    }
  }
</script>



// WEBPACK FOOTER //
// AppEditPDFTemplatesDialog.vue?fb2ff4e8